/**
 *
 * media-config actions
 *
 */

import { SET_ADOBE_TARGET } from './runtime-config-constants';

/**
 * Dispatched when the adobe target data payload is loaded
 *
 * @param  {object} data    adobe target data
 *
 * @return {object}         An action object with a type of SET_ADOBE_TARGET passing the adobe target data
 */
export const setAdobeTarget = (data) => ({
    type: SET_ADOBE_TARGET,
    data,
});
